const theme = {
  colors: {
    coral: {
      80: "#640030",
      40: "#FFBCA3",
      30: "#FDCBB2",
      "05": "#FAF6F4",
    },
    dusk: {
      80: "#24157B",
      70: "#331EA4",
      60: "#4428CE",
      50: "#5532FA",
      30: "#A695FB",
      20: "#CFC7FC",
      10: "#E3DEFD",
    },
    eucalyptus: {
      80: "#07404E",
      50: "#569F98", // #609F9A
      30: "#C0DDD6",
      20: "#E0EEEA", // #D0E6E0
      "05": "#EFF8F6", // #F0F7F5
    },
    fog: {
      80: "#191817",
      70: "#292827",
      60: "#535251",
      50: "#757474", // #777675
      40: "#A6A5A4",
      30: "#C3C2C1",
      20: "#E5E4E3",
      10: "#F7F6F5",
      "05": "#FBFAF9",
      "00": "#FFFFFF",
    },
    dawn: {
      70: "#AF4715",
      50: "#FFAE3D",
      40: "#ffd18f", // #FFCD85
    },
    ember: {
      70: "#912525",
      30: "#FF9691",
    },
    subdued: "#a3a3a2",
    green: "#4e925e",
    red: "#cc0031",
  },
  breakpoints: {
    xl: 1280 - 1, // range 1024px - 1279px
    lg: 1024 - 1, // range 768px - 1023px
    md: 768 - 1, // range 576px - 767px
    sm: 576 - 1, // range 376px - 575px
    xs: 375, // range 0 - 375px
  },
};

export { theme };
